import * as ProfileStyle from 'styles/components/common/ProfileStyle';
import { CommonWrapper, Background } from 'styles/common/Layout';
import { TextBlack, TextWhite } from 'styles/common/TextStyle';
import { ButtonSolid } from 'styles/common/ButtonStyle';
import { Image, GuideButtonImage } from 'styles/common/ImageStyle';
import { Row } from 'react-bootstrap';
import GuideImage from 'assets/images/guide.jpg';
import KioskBtnImage1 from 'assets/images/kiosk-btn-1.png';
import KioskBtnImage2 from 'assets/images/kiosk-btn-2.png';
import KioskBtnImage3 from 'assets/images/kiosk-btn-3.png';
import KioskBtnImage4 from 'assets/images/kiosk-btn-4.png';
import KioskBtnImage5 from 'assets/images/kiosk-btn-5.png';
import KioskBtnImage6 from 'assets/images/kiosk-btn-6.png';
import ExplainImage1 from 'assets/images/explain_01.gif';
import ExplainImage2 from 'assets/images/explain_02.gif';
import ExplainImage3 from 'assets/images/explain_03.gif';
import ExplainImage4 from 'assets/images/explain_04.gif';
import ExplainImage5 from 'assets/images/explain_05.gif';
import ExplainImage6 from 'assets/images/explain_06.gif';
import ExplainImage7 from 'assets/images/explain_07.gif';
import ExplainImage8 from 'assets/images/explain_08.gif';
import ExplainImage9 from 'assets/images/explain_09.gif';
import ExplainImage10 from 'assets/images/explain_10.gif';
import ExplainImage11 from 'assets/images/explain_11.gif';
import ExplainImage12 from 'assets/images/explain_12.gif';
import ExplainImage13 from 'assets/images/explain_13.gif';
import ExplainImage15 from 'assets/images/explain_15.gif';
import ExplainImage16 from 'assets/images/explain_16.gif';
import LoginImage from 'assets/images/log-in.gif';
import QRImage from 'assets/images/qrcode.gif';

function Guide() {
  const imageHeight = "128px";

  return (
    <>
      <ProfileStyle.Background
        style={{ position: "relative", top: 0, zIndex: 0 }}
      >
        <ProfileStyle.Layout>
          <ProfileStyle.TextWrapper>
            <TextWhite size="21px" weight="600" margin="0 0 5px 0">
              이용 안내
            </TextWhite>
          </ProfileStyle.TextWrapper>
        </ProfileStyle.Layout>
      </ProfileStyle.Background>
      <Background>
        <CommonWrapper padding="40px 20px" style={{ position: "relative" }}>
          <ButtonSolid marginBottom="15px" disabled>
            이용순서 1단계 : 회원가입 (픽시 및 탄소중립포인트 녹색생활실천)
          </ButtonSolid>
          <img src={GuideImage} alt="signup guide" style={{ width: "100%" }} />
        </CommonWrapper>
        <CommonWrapper
          padding="20px 20px 40px 20px"
          style={{ position: "relative" }}
        >
          <ButtonSolid marginBottom="15px" disabled>
            이용순서 2단계 : 픽시앱
          </ButtonSolid>
          <TextBlack lineHeight="1.5" className="pb-2">
            ① 빈 세제 용기를 지참하고 아파트 단지내 셀프리필스테이션을 찾아
            리필기 앞에 섭니다. (카카오맵 또는 네이버맵에서 ‘셀프 세제리필
            스테이션’ 검색)
          </TextBlack>
          <TextBlack lineHeight="1.5" className="pb-1">
            <p>
              ② 스마트폰으로 리필기에 부착된{" "}
              <GuideButtonImage src={KioskBtnImage1} alt="pickc qrcode" />를
              스캔합니다.
            </p>
            <p>
              (리플렛 앞면에도{" "}
              <GuideButtonImage src={KioskBtnImage1} alt="pickc qrcode" />가
              있습니다.)
            </p>
          </TextBlack>
          <Image
            src={ExplainImage1}
            height={imageHeight}
            className="pt-1 mb-3"
          />
          <TextBlack lineHeight="1.5" className="pb-1">
            <p>③ ‘픽시앱’ 설치를 완료합니다.</p>
            <p>
              ‘바탕화면에 앱을 설치하기’를 하시면 다음 이용부터는 설치된
              ‘픽시앱’으로 이용가능 (② 생략)
            </p>
          </TextBlack>
          <Image
            src={ExplainImage2}
            height={imageHeight}
            className="pt-1 mb-3"
          />
          <TextBlack lineHeight="1.5" className="pb-1">
            <p>
              ④ ‘픽시앱’이 열리면 ‘로그인’ 합니다. (회원 미가입 시, 회원가입부터
              해주세요.)
            </p>
            <p>
              ※ 비회원 구매로 이용은 가능하지만, 비회원은 인센티브 혜택이
              없습니다.
            </p>
          </TextBlack>
          <Image src={LoginImage} height={imageHeight} className="pt-1 mb-3" />
          <TextBlack lineHeight="1.5" className="pb-2">
            <p>⑤ ‘나의 QR코드’가 생성된 것을 확인합니다.</p>
            <p>
              ※ 내 정보에서 ‘자동 로그인’을 체크해 놓으시면, 별도의 로그인 절차
              없이 ‘나의 QR코드’가 바로 열립니다.
            </p>
          </TextBlack>
          <Image src={QRImage} height={imageHeight} className="pt-1" />
        </CommonWrapper>
        <CommonWrapper
          padding="0 20px 20px 20px"
          style={{ position: "relative", marginBottom: "10px" }}
        >
          <ButtonSolid marginBottom="15px" disabled>
            이용순서 3단계 : 리필스테이션 (음성안내)
          </ButtonSolid>
          <TextBlack size="14px" lineHeight="1.5" className="pb-1">
            ① ‘픽시앱’에서 ‘나의 QR코드’로 리필기에 부착된{" "}
            <GuideButtonImage src={KioskBtnImage2} alt="pickc qrcode" /> 에
            ‘나의 QR코드’를 보여줍니다.
          </TextBlack>
          <Image
            src={ExplainImage3}
            height={imageHeight}
            className="pt-1 mb-3"
          />
          <TextBlack size="14px" lineHeight="1.5" className="pb-1">
            ② <GuideButtonImage src={KioskBtnImage3} alt="pickc qrcode" /> 1리터
            2천원을 신용카드 및 삼성페이로 결제합니다.
          </TextBlack>
          <Row className="gx-1 gy-1 pt-2 pb-2 align-items-center text-center">
            <Image src={ExplainImage4} height={imageHeight} className="pb-1" />
            <div className="w-auto">➡</div>
            <Image src={ExplainImage5} height={imageHeight} className="pb-1" />
            <Image src={ExplainImage6} height={imageHeight} className="pb-1" />
            <Image src={ExplainImage7} height={imageHeight} className="pb-1" />
          </Row>
          <TextBlack size="14px" lineHeight="1.5" className="pb-2">
            ③ 결제가 완료되면 추출이 승인됩니다.
          </TextBlack>
          <TextBlack size="14px" lineHeight="1.5" className="pb-1">
            ④ <GuideButtonImage src={KioskBtnImage4} alt="pickc qrcode" />{" "}
            도어를 열고 빈용기를 넣은 후, 추출구를 높낮이 조절로 잘 맞춰줍니다.
          </TextBlack>
          <Row className="gx-1 gy-1 pt-2 pb-2 align-items-center justify-self-baseline">
            <Image src={ExplainImage8} height={imageHeight} className="pb-1" />
            <div className="w-auto">➡</div>
            <Image
              src={ExplainImage9}
              height={imageHeight}
              className="pb-1 me-auto"
            />
          </Row>
          <TextBlack size="14px" lineHeight="1.5" className="pb-1">
            ⑤ ‘녹색 <GuideButtonImage src={KioskBtnImage5} alt="pickc qrcode" />{" "}
            버튼’을 눌러 담기를 시작합니다.
          </TextBlack>
          <Row className="gx-1 gy-1 pt-2 pb-2 align-items-center">
            <Image src={ExplainImage10} height={imageHeight} className="pb-1" />
            <div className="w-auto">➡</div>
            <Image src={ExplainImage11} height={imageHeight} className="pb-1" />
          </Row>
          <TextBlack size="14px" lineHeight="1.5" className="pb-1">
            <p>
              ⑥ ‘빨간색{" "}
              <GuideButtonImage src={KioskBtnImage6} alt="pickc qrcode" />{" "}
              버튼’으로 ‘추출 중단’이 가능합니다. (넘칠 때 사용)
            </p>
            <p>
              (’빨간색{" "}
              <GuideButtonImage src={KioskBtnImage6} alt="pickc qrcode" />{" "}
              버튼’을 한번 더 누르면 이용 종료되고, 잔량 및 금액은 환불되지
              않습니다.)
            </p>
          </TextBlack>
          <Image
            src={ExplainImage12}
            height={imageHeight}
            className="pt-1 mb-3"
          />
          <TextBlack size="14px" lineHeight="1.5" className="pb-1">
            ⑦ 1리터 추출이 완료되면 추출은 자동으로 멈추고, ‘키오스크 화면’에서
            ‘이어담기’ 또는 ‘종료’를 선택합니다.
          </TextBlack>
          <Image
            src={ExplainImage13}
            height={imageHeight}
            className="pt-1 mb-2"
          />
          <TextBlack size="14px" lineHeight="1.5" className="pb-2">
            ‘이어담기’를 터치하면 한번 더 결제(1리터 2천원)하고 담기를
            이어갑니다.
          </TextBlack>
          <Row className="gx-1 gy-1 pt-1 pb-2 align-items-center">
            <Image src={ExplainImage5} height={imageHeight} className="pb-1" />
            <div className="w-auto">➡</div>
            <Image src={ExplainImage11} height={imageHeight} className="pb-1" />
          </Row>
          <TextBlack className="pb-2">
            ‘종료’를 터치하면 이용 종료됩니다. 카드와 담긴 용기를 챙겨서 가시면
            됩니다.
          </TextBlack>
          <Row className="gx-1 gy-1 pt-1 pb-2 align-items-center">
            <Image src={ExplainImage15} height={imageHeight} className="pb-1" />
            <div className="w-auto">➡</div>
            <Image src={ExplainImage16} height={imageHeight} className="pb-1" />
          </Row>
        </CommonWrapper>
      </Background>
    </>
  );
}

export default Guide;
